const generateLinks = (
  modules: any,
  dashboardData: any,
  fullAccess: boolean
) => {
  // Data to verify if dashboard has data
  const dashboardsList = dashboardData?.user?.goodDataClaim?.dashboards?.map(
    (db: any) => db.name
  );
  const showContentPerformance =
    dashboardsList?.includes('analytics_cp_vt_details_v3') ||
    dashboardsList?.includes('analytics_cp_iwc_details_v2');

  const showEduvsNetwork = dashboardsList?.includes('your_edu_vs_network');

  // returns if module is enabled //
  const moduleStatus = (name: string) => {
    if (fullAccess) return true;
    return modules.find((item: any) => item.module === name).enabled;
  };
  // modules model to build links //
  const modulesModel = {
    AAP_INQUIRY_EXPLORE: moduleStatus('AAP_INQUIRY_EXPLORE'),
    AAP_INQUIRY_LISTS: moduleStatus('AAP_INQUIRY_LISTS'),
    AAP_ANALYTICS_CONTENT_PERFORMANCE:
      moduleStatus('AAP_ANALYTICS_CONTENT_PERFORMANCE') &&
      showContentPerformance,
    AAP_ANALYTICS_CONTENT_PERFORMANCE_DOWNLOAD_INQUIRIES: moduleStatus(
      'AAP_ANALYTICS_CONTENT_PERFORMANCE_DOWNLOAD_INQUIRIES'
    ),
    AAP_ANALYTICS_MY_EDU_VS_NETWORK:
      moduleStatus('AAP_ANALYTICS_MY_EDU_VS_NETWORK') && showEduvsNetwork,
  };

  // build nav links based on modulesModel //
  const links = [];
  let analytics;
  let inquiries;

  // build inquries links //
  if (modulesModel.AAP_INQUIRY_EXPLORE || modulesModel.AAP_INQUIRY_LISTS) {
    inquiries = {
      label: 'Inquiries',
      link: '/inquiries/explore',
      baseLink: '/inquiries',
      subHeaders: [],
    };

    if (modulesModel.AAP_INQUIRY_EXPLORE)
      inquiries.subHeaders.push({
        label: 'Explore',
        link: '/inquiries/explore',
        otherLinks: ['/inquiries/detail'], // these are the URLs for which the sub-header should be "active"
      });
    if (modulesModel.AAP_INQUIRY_LISTS)
      inquiries.subHeaders.push({
        label: 'Lists',
        link: '/inquiries/lists',
        otherLinks: ['/inquiries/lists'],
      });
    links.push(inquiries);
  }
  // build analytics links //
  if (
    (modulesModel.AAP_ANALYTICS_CONTENT_PERFORMANCE ||
      modulesModel.AAP_ANALYTICS_MY_EDU_VS_NETWORK) &&
    (showContentPerformance || showEduvsNetwork)
  ) {
    analytics = {
      label: 'Analytics',
      link: '/analytics',
      baseLink: '/analytics',
      subHeaders: [],
    };
    if (
      modulesModel.AAP_ANALYTICS_CONTENT_PERFORMANCE &&
      showContentPerformance
    )
      analytics.subHeaders.push({
        label: 'Content Performance',
        link: '/analytics/content-performance',
      });
    if (modulesModel.AAP_ANALYTICS_MY_EDU_VS_NETWORK && showEduvsNetwork)
      analytics.subHeaders.push({
        label: 'Your EDU vs. Network',
        link: '/analytics/edu-vs-network',
      });
    links.push(analytics);
  }

  return {
    links,
    modulesModel,
  };

  // return links;
};

export default generateLinks;
